import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
import { Rosemary } from './botanical/Rosemary';
export function Guarantee() {
  return <Section className="bg-forest-deep text-cream-warm py-24 relative overflow-hidden" data-id="element-275">
      <Rosemary className="absolute top-0 -right-10 w-72 h-72 text-moss opacity-20 blur-sm rotate-90" data-id="element-276" />
      <Rosemary className="absolute bottom-0 -left-10 w-72 h-72 text-moss opacity-20 blur-sm -rotate-90" data-id="element-277" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-278">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-honey/10 mb-8 border border-honey/20" data-id="element-279">
          <ShieldCheck className="w-10 h-10 text-honey" data-id="element-280" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-cream-warm" data-id="element-281">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-lg md:text-xl text-cream-warm/90 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-282">
          Abrís los tomos. Los usás en tu casa. Si en 7 días no es lo que
          esperabas: devolución del 100%. Sin formularios. Sin drama. Sin
          vueltas.
        </p>
        <div className="inline-block bg-white/10 px-6 py-3 rounded-full border border-white/20 font-bold tracking-wider uppercase text-sm text-honey-light" data-id="element-283">
          TASA DE DEVOLUCIONES: MENOS DEL 1%.
        </div>
      </div>
    </Section>;
}